export default __webpack_public_path__ + "static/media/ownerrez.d093dab5.png";